module.exports = __webpack_public_path__ + "static/media/iconGroupStatistics.a8080881.png";